import Drawer from '@mui/material/Drawer';
import { useEffect } from 'react';

import type { NavSectionProps } from '@components/NavSection';
import { NavSectionVertical } from '@components/NavSection';
import { Scrollbar } from '@components/Scrollbar';
import { NavigationHelp } from 'src/layouts/components/NavigationHelp';
import { usePathname } from 'src/routes/hooks';

import { mergeClasses } from '@src/utils';

import { layoutClasses } from '../core/classes';
import MenuLogo from './MenuLogo';

// ----------------------------------------------------------------------

type NavMobileProps = NavSectionProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ sx, data, open, slots, onClose, className, checkPermissions, ...other }: NavMobileProps) {
  const pathname = usePathname();

  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          className: mergeClasses([layoutClasses.nav.root, layoutClasses.nav.vertical, className]),
          sx: [
            {
              overflow: 'unset',
              bgcolor: 'var(--layout-nav-bg)',
              width: 'var(--layout-nav-mobile-width)',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ],
        },
      }}
    >
      {slots?.topArea ?? (
        <MenuLogo />
      )}

      <Scrollbar fillContent>
        <NavSectionVertical
          data={data}
          checkPermissions={checkPermissions}
          sx={{ px: 2, flex: '1 1 auto' }}
          {...other}
        />
        <NavigationHelp />
      </Scrollbar>

      {slots?.bottomArea}
    </Drawer>
  );
}
